<template>
  <div>
    <el-form :model="selectForm" ref="searchFormRef" label-width="80px" v-show="searchBoxFlag">
      <el-row :gutter="24">
        <el-col span="6">
          <el-form-item label="设备编号" prop="checkPass">
            <el-input
              clearable
              v-model="selectForm.code"
              placeholder="设备编号"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="设备名称" prop="checkPass">
            <el-input
              clearable
              v-model="selectForm.name"
              placeholder="设备名称"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="设备类型" prop="objectType">
            <el-select
              clearable
              @clear="objectTypeClear"
              :value="selectForm.typeName"
              placeholder="设备类型"
              style="width: 100%;"
            >
            <!-- :load="typeLazyLoadTree"
                  lazy -->
              <el-option :value="selectForm.typeId" show-all-levels :label="selectForm.typeName">
                <el-tree
                  node-key="id"
                  :data="treeFormData"
                  :props="treeProps"
                  
                  @node-click="typeNodeTreeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6"> </el-col>
        <el-col span="6" style="margin-top:-2px">
          <el-form-item label="所属部门" prop="deptId">
            <el-select
              :value="selectForm.deptName"
              clearable
              @clear="deptClear"
              placeholder="所属部门"
              style="width: 100%;"
              filterable
              @focus="showDetpTree = true"
            >
              <el-option
                v-show="showDetpTree"
                :value="selectForm.deptName"
                show-all-levels
                :label="selectForm.deptName"
              >
                <el-tree
                  node-key="id"
                  :data="treeFormDeptData"
                  :props="treeDeptProps"
                  @node-click="handleDeptNodeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="存放位置" prop="areaId">
            <el-select
              clearable
              @clear="areaClear"
              :value="selectForm.areaName"
              placeholder="存放位置"
              style="width: 100%;"
            >
              <el-option :value="selectForm.areaName" show-all-levels :label="selectForm.areaName">
                <el-tree
                  node-key="id"
                  :data="treeFormAreaData"
                  :props="areaTreeProps"
                  :load="areaLazyLoadTree"
                  lazy
                  @node-click="areaNodeTreeClick"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="采购价格">
            <div style="display:flex;">
              <el-input
                clearable
                placeholder="采购价格"
                v-model="selectForm.purchaseStartPrice"
                maxlength="12"
              />-
              <el-input
                clearable
                placeholder="采购价格"
                v-model="selectForm.purchaseEndPrice"
                maxlength="12"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <div style="float:right">
            <el-button icon="el-icon-search" type="primary" @click="search" size="small"> 搜索 </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>

        
      </el-row>
    </el-form>
    <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          ref="crud"
          @on-load="onLoad"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="onLoad"
        >
        <!-- <template slot="menuRight">
              <searchFromShow
                :searchBoxFlag.sync='searchBoxFlag'
                :removeHeight ='searchHeight'
                :option='option'
                :refOption="$refs.crud"
                ></searchFromShow>
            
            </template> -->
          <!-- @on-load="search" -->
          <template slot="menuLeft">
            <div v-if="isShowMenuLeft">
              <el-button type="primary" size="small" @click="addRelateDevice">新 增</el-button>
              <el-button type="primary" size="small" @click="removeChoiceDevice"
                >移除选中</el-button
              >
              <el-button type="primary" size="small" @click="removeAllDevice">移除全部</el-button>
            </div>
          </template>
          <template slot="purchasePrice" slot-scope="scope">
            <div class="money" style="text-align: right;">
              <span>{{ tool.money_format_allowvoid(scope.row.purchasePrice) }}</span>
            </div>
          </template>
        </avue-crud>
    <hr-dialog
      title="选择设备"
      v-if="addRelateDeviceFlag"
      :visible.sync="addRelateDeviceFlag"
     
      width="80%"
      :handleClose="handleClose"
    >
    <template slot="body">
       <choiceDevice :projectId="projectId" :standardId="this.standardId"></choiceDevice> 
    </template>
     
    </hr-dialog>
  </div>
</template>

<script>
import {
  getRelatedDevice,
  removeRelationDevice,
  lookStandardStopDevice,
} from '@/api/crmedical/device/deviceRelation';

import { tree } from '@/api/crmedical/device/devicetype';
import { lazyAreaTree } from '@/api/crmedical/order/order-list/order-list';

import { lazyTree } from '@/api/crmedical/project/area';
import choiceDevice from '@/components/device/deviceRelation/choiceDeviceRelation';
import { treeByProjectDeptId } from '@/api/crmedical/device/device';
import searchFromShow from '@/components/search-form-show/index'
export default {
  props: ['projectId', 'standardId', 'isShowMenuLeft'],
  components: {
    choiceDevice,
    searchFromShow
  },
  data() {
    return {
      searchBoxFlag:true,
        searchHeight:'',
      deviceIds: '',
      showDetpTree: false,
      addRelateDeviceFlag: false, //新增关联设备对话框
      selectForm: {
        objectType: '',
        name: '',
        deptId: '',
        areaId: '',
        deptName: '',
        areaName: '',
        typeId: '',
        typeName: '',
        purchaseStartPrice: '',
        purchaseEndPrice: '',
      },
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'children',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'title',
      },
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      areaTreeProps: {
        //标题
        label: 'name',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'hasChildren',
        //本节点类型key值
        objectType: 'id',
        //本节点类型名
        objectTypeName: 'name',
      },
      treeFormAreaData: [], //所属区域
      treeFormDeptData: [], //所属部门
      treeFormData: [], //设备类型
      deviceList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        tip: false,
        border: true,
        index: true,
        selection: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        columnBtn: false,
        column: [
          {
            label: '设备名称',
            prop: 'name',
          },
          {
            label: '设备编号',
            prop: 'code',
          },
          {
            label: '设备类型',
            prop: 'typeName',
          },

          {
            label: '采购价格',
            prop: 'purchasePrice',
            slot: true,
          },
          {
            label: '所属部门',
            prop: 'deptName',
          },
          {
            label: '存放位置',
            prop: 'areaName',
          },
          {
            label: '设备品牌',
            prop: 'brand',
          },
          {
            label: '启用时间',
            prop: 'startUseTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
          {
            label: '报废时间',
            prop: 'scrapTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
          {
            label: '责任人',
            prop: 'chargeManName',
          },
        ],
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      data: [],
    };
  },
  created() {
    console.log('1111', this.projectId);
    this.initData();
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 379;
    },
    areaClear() {
      this.selectForm.areaName = '';
      this.selectForm.areaId = '';
    },
    deptClear() {
      this.selectForm.deptName = '';
      this.selectForm.deptId = '';
    },
    objectTypeClear() {
      this.selectForm.typeId = '';
      this.selectForm.typeName = '';
    },
    searchClear() {
      this.selectForm = {
        projectId: '',
        objectType: '',
        name: '',
        deptId: '',
        areaId: '',
        deptName: '',
        areaName: '',
        typeId: '',
        typeName: '',
        purchaseStartPrice: '',
        purchaseEndPrice: '',
      };
      this.selectForm.projectId = this.projectId;
    },
    handleClose() {
      this.addRelateDeviceFlag = false;
      this.onLoad();
    },
    search() {
      this.page.currentPage = 1;
      this.onLoad();
    },
    removeChoiceDevice() {
      console.log('设备');
      if (this.deviceIds) {
        removeRelationDevice({
          ids: this.deviceIds,
          standardId: this.standardId,
          projectId: this.projectId,
          current: this.page.currentPage,
          size: this.page.pageSize,
        }).then(() => {
          this.$message.success('移除关联成功');
          this.onLoad();
        });
      } else {
        this.$message({
          showClose: true,
          message: '没有勾选任何设备',
          type: 'warning',
        });
        return;
      }
    },
    removeAllDevice() {
      if (this.page.total > 0) {
        console.log('', this.projectId);
        removeRelationDevice(
          Object.assign(
            {},
            {
              standardId: this.standardId,
              projectId: this.projectId,
            },
            this.relateAllDeviceForm
          )
        ).then(() => {
          this.$message.success('移除所有关联成功');
          this.onLoad();
        });
      } else {
        this.$message({
          showClose: true,
          message: '没有可移除的设备',
          type: 'warning',
        });
        return;
      }
    },
    selectionChange(val) {
      console.log(val);
      let Ids = [];
      val.forEach((element) => {
        Ids.push(element.id);
      });
      this.deviceIds = Ids.join(',');
    },
    addRelateDevice() {
      this.addRelateDeviceFlag = true;
    },
    submitData() {
      this.$emit('choiceData', this.radio);
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      console.log(this.selectForm);
      if (
        (this.selectForm.purchaseStartPrice == '' && this.selectForm.purchaseEndPrice == '') ||
        (reg.test(this.selectForm.purchaseStartPrice) && reg.test(this.selectForm.purchaseEndPrice))
      ) {
        if (this.selectForm.purchaseStartPrice > this.selectForm.purchaseEndPrice) {
          //大金额在后面
          let transfromNum = this.selectForm.purchaseEndPrice;
          this.selectForm.purchaseEndPrice = this.selectForm.purchaseStartPrice;
          this.selectForm.purchaseStartPrice = transfromNum;
        }
      } else {
        let sum =
          Number(this.selectForm.purchaseStartPrice) + Number(this.selectForm.purchaseEndPrice);
        if (sum == this.selectForm.purchaseStartPrice || sum == this.selectForm.purchaseEndPrice) {
          this.$message.error('请输入一个金额范围');
          this.loading = false;
          return;
        } else {
          this.$message.error('金额格式不正确，请输入小数点前9位，后2位');
          this.loading = false;
          return;
        }
      }
      this.relateAllDeviceForm = Object.assign({}, this.selectForm);
      if (this.isShowMenuLeft) {
        getRelatedDevice(
          Object.assign(
            {},
            {
              current: this.page.currentPage,
              size: this.page.pageSize,
              standardId: this.standardId,
              projectId: this.projectId,
            },
            this.selectForm
          )
        ).then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        });
      } else {
        lookStandardStopDevice(
          Object.assign(
            {},
            {
              current: this.page.currentPage,
              size: this.page.pageSize,
              standardId: this.standardId,
              projectId: this.projectId,
            },
            this.selectForm
          )
        ).then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        });
      }
    },
    initData() {
      //   getDictionary('device_object_type').then(({ data }) => {
      //     this.objectType = data;
      //   });
      // this.queryAreaSelect(this.projectId);
      this.treeByProjectDeptId(this.projectId);
      this.queryDeviceSelect(this.projectId);
    },
    getObjectTypeName(dictKey) {
      let ObjectTypeName;
      this.objectType.forEach((element) => {
        if (element.dictKey == dictKey) {
          ObjectTypeName = element.dictValue;
        }
      });
      return ObjectTypeName;
    },
    //选中的设备提交
    choiceSubmit() {
      this.$emit('choiceData', this.radio);
    },

    queryAreaSelect(value) {
      lazyTree({ parentId: 0, projectId: value }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
            if (item.nodeType === 1) {
              item.disabled = true;
            }
          });
        }
        this.treeFormAreaData = data;
      });
    },
    queryDeviceSelect(value) {
      tree({ id: 0, projectId: value, objectType: 1 }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        this.treeFormData = data;
      });
    },
    typeNodeTreeClick(node) {
      console.log(node);
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm.typeName = nodeTitle;
      this.selectForm.typeId = nodeId;
    },
    areaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      lazyAreaTree({ parentId: id, projectId: this.projectId }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        }
        resolve(data);
      });
    },
    areaNodeTreeClick(node) {
      // if (parseInt(node.nodeType) == 1) {
      //   // this.$message.error();
      //   return;
      // }
      let nodeId = node.id;
      let nodeTitle = node.name;
      this.selectForm.areaName = nodeTitle;
      this.selectForm.areaId = nodeId;
    },
    treeByProjectDeptId(value) {
      treeByProjectDeptId({ projectId: value }).then((res) => {
        this.treeFormDeptData = res.data;
      });
    },
    handleDeptNodeClick(node) {
      //  if (parseInt(node.nodeType) == 1) {
      //     // this.$message.error();
      //     return;
      //   }
      let nodeId = node.id;
      let nodeTitle = node.title;
      this.selectForm.deptName = nodeTitle;
      this.selectForm.deptId = nodeId;
      console.log(node);
    },
    typeLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      tree({ id: id, projectId: this.projectId, objectType: 1 }).then(({ data }) => {
        if (data instanceof Array) {
          data.forEach((item) => {
            item.hasChildren = !item.hasChildren;
          });
        } else {
          data = [];
        }
        resolve(data);
      });
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
/* ::v-deep .el-table--small {
  height: 330px!important;
} */
</style>
